import React, { useEffect, useState } from "react";
import { DeviceMobile, ShareNetwork, Plus, X } from "@phosphor-icons/react";

const KEY = "tally:install-dismissed";

/** One-time "Add to Home Screen" hint for iOS Safari visitors. */
export default function InstallHint() {
  const [show, setShow] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (localStorage.getItem(KEY) === "1") return;

    const ua = window.navigator.userAgent;
    const isIOS = /iPad|iPhone|iPod/.test(ua);
    const isSafari = /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS/.test(ua);
    // Already added to home screen → standalone display mode
    const isStandalone =
      window.matchMedia?.("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;
    if (isIOS && isSafari && !isStandalone) setShow(true);
  }, []);

  const dismiss = () => {
    try { localStorage.setItem(KEY, "1"); } catch {}
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="card-organic p-4 mt-4 relative" data-testid="install-hint">
      <button
        onClick={dismiss}
        className="absolute top-3 right-3 text-[#5C6B62] hover:text-[#1A2421]"
        aria-label="Dismiss"
        data-testid="install-hint-dismiss"
      >
        <X size={14} />
      </button>
      <button
        onClick={() => setExpanded((v) => !v)}
        className="w-full flex items-center gap-3 text-left"
        data-testid="install-hint-toggle"
      >
        <span className="w-10 h-10 rounded-full bg-[#2B422F] flex items-center justify-center shrink-0">
          <DeviceMobile size={18} weight="regular" className="text-[#E6D4C4]" />
        </span>
        <div className="flex-1">
          <div className="text-sm font-medium text-[#1A2421]">Use Tally like an app</div>
          <div className="text-xs text-[#5C6B62] mt-0.5">Add to your home screen — {expanded ? "tap to hide" : "tap to see how"}</div>
        </div>
      </button>

      {expanded && (
        <ol className="mt-3 ml-12 space-y-1.5 text-xs text-[#5C6B62] leading-relaxed">
          <li className="flex items-start gap-1.5">
            <span className="text-[#1A2421] font-medium">1.</span>
            <span>Tap <ShareNetwork size={11} className="inline" weight="bold" /> <strong className="text-[#1A2421]">Share</strong> at the bottom of Safari</span>
          </li>
          <li className="flex items-start gap-1.5">
            <span className="text-[#1A2421] font-medium">2.</span>
            <span>Scroll down → tap <Plus size={11} className="inline" weight="bold" /> <strong className="text-[#1A2421]">Add to Home Screen</strong></span>
          </li>
          <li className="flex items-start gap-1.5">
            <span className="text-[#1A2421] font-medium">3.</span>
            <span>Tap <strong className="text-[#1A2421]">Add</strong> — Tally is now on your home screen!</span>
          </li>
        </ol>
      )}
    </div>
  );
}
